import { render, staticRenderFns } from "./InformationForecast.vue?vue&type=template&id=5196bf9d&"
import script from "./InformationForecast.vue?vue&type=script&lang=js&"
export * from "./InformationForecast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports